import { BlogPost } from '../blog';

import { IntroPost } from './post';

export default function Post() {
  const intro = IntroPost();

  return <BlogPost {...intro} />;
}
